export default "__VITE_ASSET__BMBsOikG__"